var map = {
	"./apps": 24643,
	"./apps.json": 24643,
	"./default": 65317,
	"./default.json": 65317,
	"./forms/accessibility": 45898,
	"./forms/accessibility.json": 45898,
	"./forms/app-manager": 61138,
	"./forms/app-manager.json": 61138,
	"./forms/auth": 72841,
	"./forms/auth.json": 72841,
	"./forms/customization": 66054,
	"./forms/customization.json": 66054,
	"./forms/info-section/widgets/button": 60676,
	"./forms/info-section/widgets/button.json": 60676,
	"./forms/info-section/widgets/image": 6654,
	"./forms/info-section/widgets/image.json": 6654,
	"./forms/info-section/widgets/qr": 1070,
	"./forms/info-section/widgets/qr.json": 1070,
	"./forms/info-section/widgets/text": 74341,
	"./forms/info-section/widgets/text.json": 74341,
	"./forms/machine/flex": 92329,
	"./forms/machine/flex.json": 92329,
	"./forms/machine/smartconference": 26979,
	"./forms/machine/smartconference.json": 26979,
	"./forms/network/dns": 4015,
	"./forms/network/dns.json": 4015,
	"./forms/network/vpn/openvpn": 21988,
	"./forms/network/vpn/openvpn.json": 21988,
	"./forms/network/wifi": 60024,
	"./forms/network/wifi.json": 60024,
	"./forms/organization/auth": 41745,
	"./forms/organization/auth.json": 41745,
	"./forms/screensaver": 29627,
	"./forms/screensaver.json": 29627,
	"./forms/sessions/browser": 17041,
	"./forms/sessions/browser.json": 17041,
	"./forms/sessions/webapp": 15917,
	"./forms/sessions/webapp.json": 15917,
	"./rootschema": 43324,
	"./rootschema.json": 43324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85272;